import {get, post} from "../../../utils/http";
import {api} from "../../../utils/api";

class AlibabaProductApi {
  list(data) {
    return get(api.alibabaProductList, data)
  }

  getCategory(categoryId) {
    return get(api.alibabaCategory, {
      categoryId
    })
  }

  info(offerId) {
    return get(api.alibabaProductInfo, {offerId})
  }
  platform(){
    return get(api.alibabaShopPlatform)
  }
  // relationAdd(data) {
  //   return post(api.alibabaProductRelationAdd, data)
  // }
  // test(){
  //   return get(api.alibabatest)
  // }
  alibabaProductCloneCheck(offerIds){
    return post(api.alibabaProductCloneCheck,{offerIds})
  }
  appShopUrl(){
    return get(api.alibabaAppShopUrl)
  }
  checkSupport(productIds){
    return post(api.alibabaCheckSupport,{productIds})
  }
}

const alibabaProductApi = new AlibabaProductApi();
export default alibabaProductApi;



// WEBPACK FOOTER //
// ./src/views/alibaba/product/api.js